module.exports = __webpack_public_path__ + "static/media/star1.21fd7bf3.png";